import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import { TextField, TextFieldProps, useRecordContext } from 'react-admin';

interface TextCopyField1Props extends Omit<TextFieldProps, 'children' | 'render'> {
  source: string,
}

function copyToClipboard(text: string) {
  if ((window as any).clipboardData && (window as any).clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return (window as any).clipboardData.setData("Text", text);
  } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    let textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy");  // Security exception may be thrown by some browsers.
    }
    catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return prompt("Copy to clipboard: Ctrl+C, Enter", text);
    }
    finally {
      document.body.removeChild(textarea);
    }
  }
}
const TextCopyField1 = (props: TextCopyField1Props) => {
  const record = useRecordContext();
  const { source } = props;

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <IconButton
        aria-label="Copy field value"
        onClick={() => copyToClipboard(record[source])}
        onMouseDown={() => copyToClipboard(record[source])}
        edge="start"
        size="small"

        sx={{padding: "0 .2rem 0 0"}}
      >
        <ContentCopyIcon fontSize="small"/>
      </IconButton>

      <TextField {...props} sx={{ flexGrow: 1 }} />
    </div >
  )
}

TextCopyField1.defaultProps = {
}

export default TextCopyField1;
